import * as Common from "@web/common/Common";
import * as React from "react";

import * as LandingCommon from "./LandingCommon";

interface IProps {
	setup(owner: boolean): void;
}

const SubscriptionView: React.FunctionComponent<IProps> = (props: IProps) => (
	<div className="mx-2 w-full md:w-auto md:min-w-96">
		<LandingCommon.CenterHeader text="DO YOU HAVE A SOMEWEAR HOTSPOT?" />
		<div className="px-10">
			<LandingCommon.FirstInput>
				<LandingCommon.Button onClick={() => props.setup(true)}>
					<Common.TitleButtonText> YES - LET'S GET SET UP! </Common.TitleButtonText>
				</LandingCommon.Button>
			</LandingCommon.FirstInput>
			<Common.CenterContent>
				<LandingCommon.Button onClick={() => props.setup(false)}>
					<Common.TitleButtonText> NO, NOT YET </Common.TitleButtonText>
				</LandingCommon.Button>
			</Common.CenterContent>
		</div>
	</div>
);

export default SubscriptionView;
